import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../../../api/request';
import { AuthenticationError } from '../../../../../../api/requests/tuitionProcess';
import { createFetchContext } from '../../../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../../../components/info/DisplayError';
import Loading from '../../../../../../components/info/Loading';
import { getFormData } from '../../../api';
import { FormDataResponse } from '../../../types/SurveyDraftFormData';

interface BaseLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  FormDataResponse, // response
  AuthenticationError | AxiosResultDefaultError
>();

export function useSurveyLoader() {
  return useFetch();
}

export const SurveyCreateLoaderConsumer = FetchConsumer;

export default function SurveyCreateLoader({ children }: BaseLoaderProps) {
  const request = useCallback(async () => {
    return getFormData();
  }, []);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ loading, data, error, refresh }) => {
          if (loading) {
            return <Loading insideCard />;
          } else if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
              />
            );
          } else if (data) {
            return children;
          } else {
            return null;
          }
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
